import { ApplicationState } from '../definitions';
import { selectCurrentFacility } from '../zone/selector';
export const selectAllEventsFromCurrentFacility = (as: ApplicationState) => {
  const fac = selectCurrentFacility(as);

  return as.eventData[fac.id];
};
